<template>
  <div class="crud_module--rsr_reset_charger">
    <Popup ref="reset_charger">
      <div class="reset_charger">
        <div class="content" v-loading="loading">
          <div class="row">
            <div class="field">
              <div class="label-group">
                <label class="label">{{ $t("field.user_log.type") }}</label>
                <select v-model="input.type">
                  <option value="Hard">Hard</option>
                  <option value="Soft">Soft</option>
                </select>
              </div>
            </div>
          </div>
          <div class="action-btn">
            <el-button type="primary" @click="rsrResetCharger">{{
              $t("button.confirm")
            }}</el-button>
          </div>
        </div>
      </div>
    </Popup>
    <el-button type="info" @click="showPopup">{{
      $t("label.reset_charger")
    }}</el-button>
  </div>
</template>

<script>
export default {
  props: ["data"],
  components: {},
  async beforeMount() {
    this.key = this.$route.params.key;
    this.id = this.$route.params.id;
  },
  methods: {
    async showPopup() {
      this.$refs.reset_charger.show();
    },
    async rsrResetCharger() {
      let action = this.$t("label.reset_charger");
      let message = this.$t("message.confirm_start_charger", {action : action});
      let confirm = await this.$confirm(message, message, {
        confirmButtonText: action,
        cancelButtonText: "取消",
        type: "warning",
      });
      if (!confirm) return;

      await this.$axios
        .get(`/${this.key}/rsrResetCharger/${this.id}?type=${this.input.type}`, {})
        .then((res) => {
          if (res.data?.status == "success") {
            this.$message({
              message: this.$t("success"),
              type: "success",
            });
          }
        })
        .catch((err) => {
          this.$message({
            message: this.$t("error.generic"),
            type: "error",
          });
          return false;
        });
    },
  },
  data() {
    return {
      key: "",
      id: 0,
      loading: false,
      connectors: [],
      input: {
        type: "Hard"
      },
    };
  },
};
</script>

<style lang="scss">
.crud_module--rsr_reset_charger {
  display: inline-block;
  margin-top: 10px;
  margin-left: 10px;
  .el-button--info {
    background-color: #909399;
  }
  .reset_charger {
    padding: 20px;
    height: auto;
    width: 200px;
    background: white;
    // overflow-y: auto;
    .action-btn {
      display: flex;
      justify-content: space-between;
      margin-bottom: 15px;
      .export-btn {
        display: flex;
        justify-content: flex-end;
      }
    }
    .content {
      // padding: 20px;
      .detail {
        .item {
          font-size: 12px;
          margin-bottom: 10px;
          .data {
            width: 100%;
            display: flex;
          }
          .label {
            width: 130px;
            min-width: 130px;
            display: flex;
            align-items: center;
          }
          .data {
            .value {
              min-width: 200px;
              width: 100%;
              border: 1px solid gray;
              background-color: #e6e6e6 !important;
              padding: 3px 5px;
            }
          }
        }
      }
      .row {
        display: flex;
        width: 100%;
        margin-bottom: 10px;
        & > .field {
          flex-grow: 1;
          // width: 100%;
          max-width: 100%;
          & > :first-child {
            margin-right: 5px;
          }
          &:not(:first-child) {
            margin-left: 5px;
          }
        }

        .label-group,
        .control-group {
          display: flex;
          flex-direction: column;
          justify-content: center;
          .label {
            // width: 150px;
            // min-width: 150px;
          }
          input:not([type="checkbox"]) {
            height: 30px;
            // width: 100%;
          }
          select {
            height: 30px;
            padding: 1px 2px;
          }
          textarea {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
